import { useQuery } from "@tanstack/react-query";
import { upcomingEncountersQueryOptions } from "../../encounters/api/queries";
import NoPreviewCard from "./cards/no-preview-card";
import UpcomingEncounterCard from "./cards/upcoming-encounter-card";
import { getRouteApi, Link } from "@tanstack/react-router";
import { getApiProgram } from "~/lib/utils";
import { QUICK_ACTIONS_POLLING_INTERVAL } from "../types/constant";

const UpcomingPreview = () => {
  const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
  const { program } = routeApi.useParams();
  const apiProgram = getApiProgram(program)
  const { data: upcomingEncountersData } = useQuery(
    { ...upcomingEncountersQueryOptions({ limit: 10, skip: 0, date_filter: "all", filter: "all", program: apiProgram, status: "unresolved" }), refetchInterval: QUICK_ACTIONS_POLLING_INTERVAL }
  );
  console.log("upcomingEncounters", upcomingEncountersData)

  const upcomingEncounters = upcomingEncountersData?.encounters ?? [];
  const totalCount = upcomingEncountersData?.totalCount ?? 0;

  // Filter encounters first, then check if there are any left
  const filteredEncounters = upcomingEncounters.filter((_enc, i, arr) => {
    // remove the first appointment encounter
    const firstAppointmentIndex = arr.findIndex(e => e.type === "appointment");
    if (firstAppointmentIndex !== -1 && i === firstAppointmentIndex) return false;

    // remove the first consultation encounter
    const firstConsultationIndex = arr.findIndex(e => e.type === "consultation");
    if (firstConsultationIndex !== -1 && i === firstConsultationIndex) return false;

    // remove the first refill encounter
    const firstRefillIndex = arr.findIndex(e => e.type === "refill");
    if (firstRefillIndex !== -1 && i === firstRefillIndex) return false;

    return true;
  });

  // Calculate remaining unresolved encounters
  const remainingCount = totalCount - filteredEncounters.length;

  return (
    <div
      className="flex flex-col gap-3 md:gap-4 w-full"
      aria-label="upcoming-appointments"
      role="region"
    >
      <h2 className="text-xl md:text-2xl font-medium">Upcoming</h2>

      <div className="flex flex-col gap-3 md:gap-4 w-full max-h-[calc(100vh-6rem)] overflow-y-auto pr-2 hide-scrollbar">
        {filteredEncounters.length > 0 ? (
          <>
            {filteredEncounters.map((encounter, index) => (
              <UpcomingEncounterCard
                key={index}
                item={encounter}
                program={program}
              />
            ))}
            {remainingCount > 0 && (
              <Link
                to="/dashboard/$program/encounters/$tab"
                params={{ program, tab: "all" }}
                className="text-sm text-[#4272DD] underline hover:text-[#2d5bb3] cursor-pointer self-start"
              >
                +{remainingCount} More…View all encounters
              </Link>
            )}
          </>
        ) : (
          <NoPreviewCard
            icon={program === "urgent-care" ? "/assets/file.png" : "/assets/appointments.svg"}
            title={"Nothing to Display"}
            description={"You have no encounters to see today, when you do, they will appear here"}
            className="w-full h-auto min-h-[300px] md:min-h-[350px] lg:min-h-[440px]"
          />
        )}
      </div>

    </div>
  );
};

export default UpcomingPreview;